export interface DefaultAddinsDetails {
    Id: string;
    Name: string;
}

/*
This file contains the details of the Default add-ins sorted according to their name
@Fields
'ID': The addin or product ID of the add-in
'Name': Name of the addin - this corresponds to the display name from the manifest
*/
export const DefaultAddinsDetailsList: DefaultAddinsDetails[] = [
    {
        Id: "7a774f0c-7a6f-11e0-85ad-07fb4824019b",
        Name: "Bing Maps",
    },
    {
        Id: "a216ceed-7791-4635-a752-5a4ac0a5eb93",
        Name: "My Templates",
    },
    {
        Id: "d39dee0e-fdc3-4015-af8d-94d4d49294b3",
        Name: "Unsubscribe",
    },
];
